interface JsonErrorObject {
  status: number,
  source: any,
  detail: string,
}

export interface RailsFormat {
  serializeForRails(model: any): any
}

export class Model {

  public errors: any = {}

  constructor() {}

  static getJsonApiErrors(errors: JsonErrorObject[]) {
    return errors.reduce((obj, { source, detail }) => {
      const key = source.pointer.split('/').pop();
      const value = typeof detail === 'string' ? { message: detail } : detail;
      return { ...obj, [key]: value };
    }, {});
  }

  static serverError: any = {
    server: {
      message: 'An error occured processing your request.'
    },
  }
}



// WEBPACK FOOTER //
// /Users/jason/src/matrix/client/src/app/models/model.ts